import { render, staticRenderFns } from "./DriverProfile.vue?vue&type=template&id=5502977f&scoped=true&"
import script from "./DriverProfile.vue?vue&type=script&lang=js&"
export * from "./DriverProfile.vue?vue&type=script&lang=js&"
import style0 from "./DriverProfile.vue?vue&type=style&index=0&id=5502977f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5502977f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5502977f')) {
      api.createRecord('5502977f', component.options)
    } else {
      api.reload('5502977f', component.options)
    }
    module.hot.accept("./DriverProfile.vue?vue&type=template&id=5502977f&scoped=true&", function () {
      api.rerender('5502977f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Map/components/DriverProfile.vue"
export default component.exports